import React, { useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';

import style from '../../../../components/grid-header/reusable-grid-button.module.less';
import { useDataExportFeatureGate } from '../../../../feature-gates/use-data-export-feature-gate';
import messages from '../../messages';
import ExportTypeModal from '../modals/export/export-type-modal';

/**
 * @returns {React.JSX.Element}
 */
const ExportButton = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { isFeatureEnabled, disabledMessage } = useDataExportFeatureGate();

  const onCloseModal = useCallback(() => {
    setIsModalOpen(!isModalOpen);
  }, [isModalOpen, setIsModalOpen]);

  const disabledTooltipMessage = disabledMessage ? <FormattedMessage {...disabledMessage} /> : undefined;

  return (
    <>
      <Button
        className={style['reusable-button']}
        disabled={!isFeatureEnabled}
        disabledTooltipMessage={disabledTooltipMessage}
        onClick={onCloseModal}
        theme='tertiary'
      >
        <FormattedMessage {...messages.productGridExportsButton} />
      </Button>
      {isModalOpen ? <ExportTypeModal onCloseModal={onCloseModal} /> : null}
    </>
  );
};

export default ExportButton;
